/**
 * ============================================================
 * MONTE HERMOM | MENU PARADIGMA LATERAL
 * ============================================================
 *
 * ARQUIVO: MenuParadigmaLateral.jsx
 * VERSÃO: 1.1.0
 * DATA: 18/02/2026
 *
 * OBJETIVO:
 * Menu estrutural do sistema (infraestrutura).
 * Responsável por:
 *  - Navegação principal
 *  - Exibição da identidade do usuário (PerfilCard)
 *
 * NÃO RESPONSÁVEL POR:
 *  - Login
 *  - Sessão
 *  - Segurança
 *
 * ============================================================
 */

import React from 'react';
import { NavLink } from 'react-router-dom';

// Contexto de autenticação (já existente)
import { useAuthSaaS } from '../../context/AuthSaaSContext';

// Perfil
import PerfilCard from '../dashboard/cards/Perfil_card';

export default function MenuParadigmaLateral() {
  const { usuario } = useAuthSaaS();

  return (
    <aside className="w-80 bg-[#050505] border-r border-white/5 flex flex-col p-6">

      {/* ======================================================
         IDENTIDADE DO USUÁRIO (PERFIL + SELO)
         ====================================================== */}
      <div className="mb-8">
        <PerfilCard user={usuario} />
      </div>

      {/* ======================================================
         NAVEGAÇÃO PRINCIPAL
         ====================================================== */}
      <nav className="flex-1 space-y-2">

        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            `block px-5 py-3 rounded-xl text-sm font-black uppercase tracking-wide
             ${isActive ? 'bg-red-600/10 text-red-600' : 'text-white/60 hover:text-white'}`
          }
        >
          Dashboard
        </NavLink>

        <NavLink
          to="/laudos"
          className="block px-5 py-3 rounded-xl text-sm font-black uppercase tracking-wide text-white/60 hover:text-white"
        >
          Laudos
        </NavLink>

        <NavLink
          to="/vistorias"
          className="block px-5 py-3 rounded-xl text-sm font-black uppercase tracking-wide text-white/60 hover:text-white"
        >
          Vistorias
        </NavLink>

      </nav>

      {/* ======================================================
         RODAPÉ INSTITUCIONAL
         ====================================================== */}
      <div className="pt-6 border-t border-white/5 text-center">
        <span className="text-[9px] text-white/30 uppercase tracking-widest font-black">
          Monte Hermom © 2026
        </span>
      </div>
    </aside>
  );
}